/** 案件包导入（第二阶段 P2-4）；受信任系统和外部编号见 trust-zh.ts。 */
export default {
  imports: {
    open: '导入案件包',
    title: '导入案件包',
    intro: '案件包是另一个系统导出的已签名文件。系统会先检查它；在您导入之前不会写入任何内容。',
    file: '案件包文件（.pcp.zip）',
    upload: '上传并检查',
    uploading: '正在上传… {{percent}}%',
    checking: '正在检查案件包…',
    committing: '正在导入…',
    recent: '最近的导入',
    resume: '查看',
    none: '尚无导入。',
    reportTitle: '检查报告',
    commit: '导入到此工作区',
    acknowledge: '关闭此导入',
    recheck: '重新检查',
    retry: '重试',
    findingsTruncated: '仅显示前 {{count}} 项检查结果。',
    fields: {
      attributes: '申请信息',
      profileRef: '规划类型',
      declaredSrid: '坐标系',
      applicant_name: '申请人姓名',
      applicant_firm: '公司',
      applicant_email: '电子邮件地址',
      applicant_professionalRegNo: '专业注册号',
      state: '申请状态',
    },
    committed: '案件包已导入。',
    closed: '未导入任何内容：此工作区已包含案件包所携带的全部内容。',
    openCase: '打开申请',
    close: '关闭',
    stepOk: '通过',
    stepFailed: '未通过',
    head: '截至第 {{seq}} 个事件的历史',
    counts: '{{events}} 个事件，{{documents}} 份文件',
    sender: {
      verified: '由 {{system}} 签名。',
      unsigned: '此案件包未签名。',
      unknown_kid: '签名所用的密钥不是您任何受信任系统发布的密钥。',
      invalid: '签名无效。',
    },
    status: {
      uploading: '等待上传…',
      queued: '等待开始…',
      validating: '正在检查案件包…',
      validated: '已检查。',
      invalid: '此案件包无法导入。',
      committing: '正在导入…',
      committed: '已导入。',
      closed: '已关闭。',
      failed: '导入已停止。',
      expired: '已上传的案件包已被删除。',
    },
    steps: {
      unzip: '解包',
      bagit: '文件与摘要',
      profile: '案件包版本',
      schemas: '内容',
      chain: '历史链',
      boundary: '移交点',
      seal: '签名',
      crs: '场地坐标',
      decide: '与此工作区比对',
    },
    findings: {
      outcome_new: '新申请：此工作区中尚无此申请。',
      outcome_fast_forward: '它接续此处保存的申请。',
      outcome_duplicate: '此案件包以前已导入。',
      outcome_stale: '此工作区已包含案件包所携带的全部内容。',
      outcome_conflict: '案件包与此工作区各自都有了新的进展，因此无法导入。',
      outcome_authority_violation: '另一个系统持有此申请，因此此发送方无法更新它。',
      package_too_large: '案件包大于 2 GB。',
      zip_unreadable: '该文件不是可读取的 zip 文件。',
      unexpected_entry: '案件包包含案件包结构之外的文件。',
      unsafe_entry_name: '案件包包含不允许的文件名。',
      compression_ratio: '案件包中某个文件解压后远大于其压缩大小。',
      digest_mismatch: '某个文件与案件包为其列出的摘要不符。',
      profile_not_importable: '公开案件包不含个人数据或文件，无法导入。',
      procedure_not_runnable: '此工作区不运行制作此案件包所用的程序。',
      chain_broken: '历史链无法验证。',
      boundary_not_reached: '案件包尚未达到其所指明的移交点。',
      seal_verified: '签名验证通过。',
      seal_missing: '此案件包未签名。',
      seal_unknown_kid: '签名密钥不是您的受信任系统发布的密钥。',
      seal_invalid: '签名验证未通过。',
      seal_required: '持有此申请的系统要求案件包必须签名。',
      seal_required_tenant:
        '此工作区拒绝未经其任何受信任系统签名的案件包。请管理员在“设置 → 规划 → 受信任系统”中添加发送系统，或关闭“拒绝未经受信任系统签名的案件包”，然后重新上传此案件包。',
      package_id_reused: '以前已导入过编号相同但内容不同的案件包。',
      local_case_deleted: '此申请在此处已被删除。',
      unknown_members_kept: '此工作区无法识别的字段会随申请一并保存。',
      external_id_taken: '案件包中的某个外部编号在此处已关联到另一个申请。',
      event_time_not_storable: '某个事件的时间写法无法被此工作区保存。',
      chain_not_storable: '历史中包含此工作区必须隐藏的值，因此在此处将无法再通过验证。',
      transition_inconsistent: '历史将申请移到其程序不允许从该处进入的阶段。',
      document_id_taken: '案件包中的某张图纸使用了此处另一个申请的图纸编号。',
      document_not_storable: '案件包中包含此工作区无法保存的原始文件：只有带编号的图纸才能导入。',
      attributes_not_storable: '案件包中的申请信息不符合此工作区的表单（{{field}}）。',
      key_not_storable: '案件包中包含此工作区无法保存的字段名。',
      unknown_member_key_invalid: '案件包中包含一个名称无法保留的未知字段。',
      event_path_invalid: '某个事件文件的名称不符合案件包的命名方式。',
      unknown_event_type: '事件 {{seq}} 的类型不为此工作区所知；已按原样保留。',
      case_urn_mismatch: 'case.json 中的案件编号与其所描述的案件不符。',
      document_mismatch: '某张图纸所列的大小与案件包中该文件的大小不符。',
      native_event_seq_invalid: '某个来自其他系统的文件关联到案件包中不存在的事件。',
      too_many_entries: '案件包包含超过 20,000 个文件。',
      total_too_large: '案件包解压后超过 4 GB。',
      entry_too_large: '案件包中某个文件大于 1 GB。',
      entry_unreadable: '案件包中某个文件无法读取。',
      small_file_too_large: '案件包中某个数据文件大于 16 MB。',
      small_total_too_large: '案件包的数据文件合计大于 256 MB。',
      duplicate_entry: '案件包中同一文件名出现了两次。',
      encrypted_entry: '案件包中某个文件已加密。',
      symlink_entry: '案件包包含指向其他文件的链接。',
      unsupported_compression: '案件包中某个文件的压缩方式无法读取。',
      bagit_txt_invalid: '案件包没有有效的 bagit.txt。',
      manifest_missing: '案件包没有其文件及摘要的清单。',
      manifest_invalid: '文件及摘要清单无法读取。',
      manifest_path_invalid: '文件清单中列出了案件包数据之外的文件。',
      manifest_entry_missing: '案件包列出的某个文件不在包中。',
      unlisted_payload: '案件包包含一个未列出的文件。',
      tag_manifest_invalid: '已签名文件清单无法读取。',
      tag_manifest_coverage: '已签名文件清单未恰好涵盖应涵盖的文件。',
      tag_file_missing: '案件包中缺少某个已签名文件。',
      tag_digest_mismatch: '某个已签名文件与其摘要不符。',
      bag_info_missing: '案件包没有 bag-info.txt。',
      bag_info_malformed: 'bag-info.txt 无法读取。',
      bag_info_missing_label: 'bag-info.txt 中没有 {{label}}。',
      bag_info_duplicate: 'bag-info.txt 中 {{label}} 出现了两次。',
      bag_info_invalid: 'bag-info.txt 中 {{label}} 的值无效。',
      payload_oxum_mismatch: 'bag-info.txt 所述的文件数量和大小与案件包不符。',
      profile_unsupported: '此工作区仅读取 {{supported}} 版本的案件包。',
      upcast_failed: '无法将案件包升级到当前版本。',
      case_json_missing: '案件包没有 case.json。',
      case_json_unreadable: 'case.json 无法读取。',
      case_schema_unsupported: 'case.json 不是案件包所指明的版本。',
      case_json_invalid: 'case.json 中有一个字段无效（{{field}}）。',
      extensions_invalid: 'case.json 中来自其他系统的数据格式无法保存。',
      unknown_members_too_large: '此工作区无法识别的字段过大，无法随申请一并保存。',
      privacy_path_invalid: 'case.json 中列出了一条无法读取的隐私规则。',
      privacy_mismatch: 'case.json 中的隐私规则与其摘要不符。',
      bag_info_mismatch: 'bag-info.txt 与 case.json 不一致（{{label}}）。',
      public_case_missing: '案件包没有 case.public.json。',
      public_case_invalid: 'case.public.json 无效、包含个人数据，或描述了另一个案件或其历史中的另一个时间点。',
      pack_mismatch: '此工作区运行该程序时使用的隐私规则与案件包不同。',
      documents_unexpected: '案件包携带了其类型从不携带的图纸清单。',
      documents_index_missing: '案件包没有图纸清单，但其历史中提到了图纸。',
      documents_index_invalid: '图纸清单无法读取。',
      document_unlisted: '清单中的某张图纸不在案件包文件中，或其摘要不符。',
      document_type_unsupported: '第 {{revision}} 版的某张图纸属于此工作区无法保存的类型。',
      document_missing: '历史在事件 {{seq}} 中提到的某张图纸不在案件包中。',
      too_many_native_files: '案件包包含超过 1,000 个来自其他系统的文件。',
      native_path_invalid: '某个来自其他系统的文件不在 case.json 所述的位置。',
      native_duplicate: 'case.json 将某个来自其他系统的文件列出了两次。',
      native_mismatch: '某个来自其他系统的文件与 case.json 所列的摘要或大小不符。',
      native_unlisted: '案件包包含一个 case.json 未列出的、来自其他系统的文件。',
      too_many_events: '案件包包含超过 10,000 个事件。',
      event_unreadable: '某个事件文件无法读取。',
      event_invalid: '某个事件文件不是有效的案件包事件。',
      event_not_canonical: '某个事件文件不是以案件包所写的确切格式写成的。',
      event_wrong_case: '某个事件文件属于另一个案件。',
      event_seq_mismatch: '某个事件文件包含的事件与其名称所示不符。',
      events_incomplete: '案件包仅包含其历史中 {{expected}} 个事件中的 {{found}} 个。',
      external_ids_mismatch: 'case.json 中的外部编号与其历史所关联的不一致。',
      chain_unverifiable: '历史链无法检查。',
      head_mismatch: '历史结束于与 case.json 所述不同的事件。',
      replay_mismatch: '重放历史得到的申请与 case.json 所描述的不一致。',
      based_on_off_chain: '案件包声称其所基于的时间点不在其历史中。',
      verified_head_off_chain: 'case.json 所指的最后验证点不在其历史中。',
      transition_unknown: '事件 {{seq}} 记录了此处程序无法执行的步骤。',
      event_type_mismatch: '事件 {{seq}} 所标注的类型与其在此处的步骤不符。',
      clock_event_invalid: '事件 {{seq}} 记录了此处程序不可能做出的期限变更。',
      stage_unknown: '历史使申请停留在此处程序中不存在的阶段。',
      landing: '申请将进入 {{stage}} 阶段。',
      seal_coverage: '签名未恰好涵盖应涵盖的文件。',
      seal_head_mismatch: '签名所指的历史时间点与案件包所含的不一致。',
      crs_unknown: '场地所用的坐标系为此工作区所不知。',
      crs_mismatch: '场地使用 EPSG:{{srid}}，而申请声明的是 EPSG:{{declaredSrid}}。',
      crs_not_offered: '场地使用 EPSG:{{srid}}，此工作区不提供该坐标系。',
      crs_out_of_range: '场地的坐标超出其坐标系范围。',
      place_out_of_range: '场地的位置超出经纬度范围。',
      place_inconsistent: '场地在不应提供经纬度副本时提供了副本，或在应提供时缺少副本。',
      ring_not_closed: '场地边界未闭合。',
      geometry_too_large: '场地的点数过多（{{vertices}} 个；最多 200,000 个）。',
      geopackage_invalid: 'site.gpkg 不是 GeoPackage 文件。',
      extension_namespace_taken: '案件包已在 {{namespace}} 下保存数据，而这正是其未知字段将被保存的名称。',
      unknown: '检查结果：{{code}}',
    },
    errors: {
      IMPORT_FAILED: '导入过程中出错。请重试。',
      IMPORT_PACKAGE_MISSING: '无法读取已上传的案件包。请重新上传。',
      IMPORT_PACKAGE_CHANGED: '已存储的案件包在检查后发生了变化。请重新上传。',
      IMPORT_OUTCOME_CHANGED:
        '自检查此案件包以来，有内容发生了变化（申请、受信任系统或导入规则）。请重新上传以再次检查。',
      IMPORT_DOCUMENT_FAILED: '无法存储案件包中的某个文件。请重试。',
      IMPORT_EXTENSIONS_TOO_LARGE: '该案件保留的其他系统数据将超过案件包可携带的上限（1 MiB），因此未导入。',
      IMPORT_STALE: '导入意外停止。请重试。',
    },
  },
  errors: {
    too_many_imports: '您已有三个案件包正在检查或导入。请等待其中一个完成。',
    invalid_import: '这些导入信息无效。',
    import_not_found: '未找到该导入。',
    import_not_uploaded: '案件包尚未上传。',
    import_not_ready: '该导入在当前状态下无法执行此操作。',
    import_outdated: '自检查此案件包以来，申请已发生变化。请重新检查。',
    import_closed: '该导入已关闭。',
    import_expired: '已上传的案件包已被删除。请重新上传。',
    stale_base: '此案件包与此处的申请记录不连续，因此未导入任何内容。',
    package_id_reused: '具有此编号的案件包已以不同内容导入。',
    recipient_not_trusted: '接收系统必须是您的受信任系统之一（“设置 → 规划”）。',
    external_id_taken: '该外部编号已关联到另一个申请。',
    invalid_external_id: '该外部编号无效。',
    invalid_trusted_system: '该受信任系统无效。',
    trusted_system_not_found: '未找到该受信任系统。',
    trusted_system_holds_cases: '该系统仍持有转交给它的申请。请先收回这些申请。',
  },
  events: {
    case_external_id_linked: '已关联外部编号',
    case_foreign_event_recorded: '已记录来自其他系统的消息',
  },
} as const
